import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/home/htsung/sakai/vuecomponents/tool/src/main/frontend/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js'
import '/home/htsung/sakai/vuecomponents/tool/src/main/frontend/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/home/htsung/sakai/vuecomponents/tool/src/main/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import conditionEditor from '~root/./src/components/condition-editor.vue?shadow'
window.customElements.define('sakai-condition-editor', wrap(Vue, conditionEditor))

import conditionPicker from '~root/./src/components/condition-picker.vue?shadow'
window.customElements.define('sakai-condition-picker', wrap(Vue, conditionPicker))

import conditionText from '~root/./src/components/condition-text.vue?shadow'
window.customElements.define('sakai-condition-text', wrap(Vue, conditionText))

import dynamicCriterion from '~root/./src/components/dynamic-criterion.vue?shadow'
window.customElements.define('sakai-dynamic-criterion', wrap(Vue, dynamicCriterion))

import dynamicRubric from '~root/./src/components/dynamic-rubric.vue?shadow'
window.customElements.define('sakai-dynamic-rubric', wrap(Vue, dynamicRubric))

import helloWorld from '~root/./src/components/hello-world.vue?shadow'
window.customElements.define('sakai-hello-world', wrap(Vue, helloWorld))

import multiGradebook from '~root/./src/components/multi-gradebook.vue?shadow'
window.customElements.define('sakai-multi-gradebook', wrap(Vue, multiGradebook))

import tagSelector from '~root/./src/components/tag-selector.vue?shadow'
window.customElements.define('sakai-tag-selector', wrap(Vue, tagSelector))

import timerBar from '~root/./src/components/timer-bar.vue?shadow'
window.customElements.define('sakai-timer-bar', wrap(Vue, timerBar))